const fontSizeToLineHeight = {
  '54': '64',
  '42': '54',
  '32': '40',
  '24': '28',
  '20': '28',
  '18': '24',
  '16': '24',
  '14': '20',
  '13': '20',
  '12': '16',
  '11': '16',
  '10': '16'
};
const getLineHeightByFontSize = (fontSizeInPx, pure) => {
  if (fontSizeToLineHeight[fontSizeInPx]) {
    return pure ? fontSizeToLineHeight[fontSizeInPx] : `${fontSizeToLineHeight[fontSizeInPx]}px`;
  }
  return '1.5em';
};
export default getLineHeightByFontSize;